(() => {
  angular
    .module('gm.common.services')
    .service('GmyPageUpdate', GmyPageUpdate);

  function GmyPageUpdate(
    $rootScope
  ) {
    'ngInject';

    return {
      update,
    };

    function update(data, defaults) {
      if (data) {
        // title data
        if ('title' in data) {
          $rootScope.gm.title = data.title;
        } else if ((defaults) && ('title' in defaults)) {
          $rootScope.gm.title = defaults.title;
        }

        // metadata
        if ('metadata' in data) {
          $rootScope.gm.metadata = $rootScope.gm.metadata || {};
          if ('author' in data.metadata) {
            $rootScope.gm.metadata.author = data.metadata.author;
          } else if ((defaults) && ('metadata' in defaults) && ('author' in defaults.metadata)) {
            $rootScope.gm.metadata.author = defaults.metadata.author;
          }

          if ('description' in data.metadata) {
            $rootScope.gm.metadata.description = data.metadata.description;
          } else if ((defaults) && ('metadata' in defaults) && ('description' in defaults.metadata)) {
            $rootScope.gm.metadata.description = defaults.metadata.description;
          }

          if ('keywords' in data.metadata) {
            $rootScope.gm.metadata.keywords = data.metadata.keywords;
          } else if ((defaults) && ('metadata' in defaults) && ('keywords' in defaults.metadata)) {
            $rootScope.gm.metadata.keywords = defaults.metadata.keywords;
          }
        }

        // body settings
        if ('bodyClass' in data) {
          $rootScope.gm.bodyClass = data.bodyClass;
        } else if ((defaults) && ('bodyClass' in defaults)) {
          $rootScope.gm.bodyClass = defaults.bodyClass;
        }

        if ('bodyWrapper' in data) {
          $rootScope.gm.bodyWrapper = data.bodyWrapper;
        } else if ((defaults) && ('bodyWrapper' in defaults)) {
          $rootScope.gm.bodyWrapper = defaults.bodyWrapper;
        }

        // header settings
        if ('header' in data) {
          $rootScope.$broadcast('gm:header', data.header);
        } else if ((defaults) && ('header' in defaults)) {
          $rootScope.$broadcast('gm:header', defaults.header);
        }

        if ('headerTheme' in data) {
          $rootScope.gm.headerTheme = data.headerTheme;
        } else if ((defaults) && ('headerTheme' in defaults)) {
          $rootScope.gm.headerTheme = defaults.headerTheme;
        }

        if ('headerTransparent' in data) {
          $rootScope.gm.headerTransparent = data.headerTransparent;
        } else if ((defaults) && ('headerTransparent' in defaults)) {
          $rootScope.gm.headerTransparent = defaults.headerTransparent;
        }

        if ('headerLightBackground' in data) {
          $rootScope.gm.headerLightBackground = data.headerLightBackground;
        } else {
          $rootScope.gm.headerLightBackground = false;
        }

        if ('showHeader' in data) {
          $rootScope.gm.showHeader = data.showHeader;
        } else if ((defaults) && ('showHeader' in defaults)) {
          $rootScope.gm.showHeader = defaults.showHeader;
        }

        if ('activeMenu' in data) {
          $rootScope.gm.activeMenu = data.activeMenu;
        } else if ((defaults) && ('activeMenu' in defaults)) {
          $rootScope.gm.activeMenu = defaults.activeMenu;
        }

        // footer settings
        if ('showFooter' in data) {
          $rootScope.gm.showFooter = data.showFooter;
        } else if ((defaults) && ('showFooter' in defaults)) {
          $rootScope.gm.showFooter = defaults.showFooter;
        }

        if ('showFooterMini' in data) {
          $rootScope.gm.showFooterMini = data.showFooterMini;
        } else if ((defaults) && ('showFooterMini' in defaults)) {
          $rootScope.gm.showFooterMini = defaults.showFooterMini;
        }
      }
    }
  }
})();
